import Vue from 'vue';
import VueRouter from 'vue-router';

import { IRoute, routeDefinition } from './route-definition';

Vue.use(VueRouter);

const routes: IRoute[] = routeDefinition;

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: 'is-active',
});

export default router;